export const MSG = {
  PERMISSION_DENIED: "权限不足",
  REFUSED: "无法连接服务，请检查网络连接",
  EXPIRED: "登录已过期，请您重新登录",
  TIMEOUT: "您的网络不太通畅, 请检查您的网络连接",
  FAILED: "服务请求失败，请您稍后再试",
  EMPTY: "暂无数据",
  PAGE_NOT_FOUND: "页面未找到",
  GO_HOME: "返回首页",
  SS_LOADING: "系统加载中，请稍后"
}

export const SIGNIN = {
  SLOGAN: "",
  USER_NAME: "用户名",
  PASSWORD: "密码",
  SIGNIN: "登录",
  SIGNING: "登录中",
  FROM_VALIDATOR_MSG: "请输入用户名和密码"
}

export const SIGNOUT = {
  SIGNOUT: "退出登录",
  CONFIRM_TITLE: "退出登录",
  CONFIRM_MSG: "确认退出此账号的登录吗？"
}
